import styled from "styled-components";

const EditorBox = styled.div<{margin?: string}>`
	margin: ${props => (props.margin ? props.margin : "")};
	overflow: hidden;
	p {
		line-height: 1.6;
		font-size: var(--default-size);
		color: var(--default-color);
		word-break: break-all;
	}

	table {
		width: 100%;
		border-top: 1px solid var(--emp-color);
		border-spacing: 0;
		border-collapse: collapse;
		box-sizing: border-box;

		thead > th {
			border-right: 1px solid var(--line-color);
		}
		tr > th {
			border-right: 1px solid var(--line-color);
			border-bottom: 1px solid var(--line-color);
		}

		td {
			padding: 20px;
			border-right: 1px solid var(--line-color);
			border-bottom: 1px solid var(--line-color);
			background: #fff;
			font-size: var(--default-size);
			line-height: 1.6;
			text-align: left;
			&:last-child {
				border-right: none;
			}
		}
		th {
			padding: 18px 0;
			background-color: var(--disabled-color);
			text-align: center;
			font-size: var(--default-size);
			color: var(--emp-color);
			&:last-child {
				border-right: none;
			}
		}
		+ p {
			margin-top: 8px;
		}
		+ table {
			margin-top: 10px;
		}
	}

	img {
		max-width: 100%;
		height: auto;
		vertical-align: top;
	}

	strong {
		font-family: "pr-font-medium";
		font-weight: normal;
	}

	hr {
		width: revert;
		height: revert;
		margin: revert;
		border: revert;
	}
	@media print {
		font-size: 24px;
		h3 {
			font-size: 18px;
		}
		p,
		h5,
		h6 {
			font-size: 18px;
			line-height: 1.6;
		}
		ul li,
		ol li {
			font-size: 18px;
			line-height: 1.6;
		}
	}
`;

const BundleEditorBox = styled.div`
	padding: 15px 10px;
	border: 1px solid var(--line-color);
	background-color: var(--disabled-color);
`;

export {EditorBox, BundleEditorBox};
